import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      paddingLeft: 0,
      paddingRight: 0,
      backgroundColor: "white",
      minHeight: "100vh",
    },
    detailWrapper: {
      padding: "8px 16px",
      paddingBottom: 16,
      backgroundColor: "#ffffff",
    },
    title: {
      fontWeight: 700,
      fontSize: 18,
    },
    address: {
      fontWeight: 500,
      color: "#a0a4a8",
    },
    rateHotel: {
      display: "flex",
      alignItems: "center",
    },
    rateText: {
      paddingLeft: 5,
      paddingRight: 8,
    },
    fasilitasWrapper: {
      padding: 16,
      backgroundColor: "#ffffff",
    },
    bold: {
      fontWeight: 700,
      fontSize: 14,
    },
    fasilitas: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    iconFasilitas: {
      height: 18,
      width: 18,
      margin: "auto",
    },
    listFasilitasWrapper: {
      paddingTop: 17,
      paddingBottom: 10,
    },
    listRoomWrapper: {
      padding: 16,
      backgroundColor: "#ffffff",
    },
    imageIndex: {
      position: "absolute",
      right: 0,
      bottom: 0,
      marginRight: 10,
      marginBottom: 12,
      display: "flex",
      alignItems: "center",
      padding: "5px 10px",
      backgroundColor: "rgb(0 0 0 / 0.8)",
      borderRadius: 5,
    },
    dot: {
      backgroundColor: "#e4e6e7",
      height: 6,
      width: 6,
      borderRadius: 6,
      margin: 3,
    },
    dotActive: {
      backgroundColor: "#9e007e",
      height: 6,
      width: 12,
      borderRadius: 6,
      margin: 3,
    },
    paginationImg: {
      position: "absolute",
      bottom: 0,
      left: 0,
      display: "flex",
      marginBottom: 12,
      marginLeft: 10,
    },
    drawerDatePicker: {
      "& .MuiDrawer-paperAnchorTop": {
        maxWidth: 444,
        width: "100%",
        position: "fixed",
        margin: "auto",
        padding: 16,
      },
    },
    titleCard: {
      color: "#52575c",
      paddingBottom: 8,
    },
    areaSearch: {
      display: "flex",
      alignItems: "flex-start",
      cursor: "pointer",
      width: "100%",
    },
    calendarIcon: {
      margin: 2,
    },
    searchLabel: {
      width: "100%",
      display: "flex",
      borderBottom: "1px solid rgba(0,0,0,.08)",
      marginBottom: 8,
      paddingBottom: 8,
    },
    totalNight: {
      position: "absolute",
      right: 0,
      paddingTop: 10,
      padding: "0 8px",
      textAlign: "center",
      backgroundColor: "#ffffff",
    },
    buttonSearch: {
      backgroundColor: "#9e007e",
      textTransform: "capitalize",
      color: "#ffffff",
      fontWeight: "bold",
      marginTop: 16,
      paddingTop: 13,
      paddingBottom: 16,
      "&:hover": {
        backgroundColor: "#9e007e",
        boxShadow: "none",
      },
      borderRadius: 0,
      boxShadow: "none",
    },
    displayDate: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: 16,
      marginBottom: 0,
      cursor: "pointer",
      border: "1px solid #C4C4C4",
    },
  })
);

export default useStyles;
